exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2WHuT {\n  overflow: hidden;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_2WHuT"
};